module.exports = __webpack_public_path__ + "static/media/personality2.eeb6cc8e.jpeg";